import { FC } from 'react';
import * as input from './graphql';
import { useForm, useFieldArray, FormProvider, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import classNames from 'classnames';
import { OwnerFields } from './OwnerFields';
import { Schema, schema } from './schema';
import { MutationFunction } from '@apollo/client';
import Button from 'jbc-front/components/Button';
import styles from './Form.scss';

interface Props {
  owners: input.Owner[];
  answerRequest: MutationFunction<input.Data>;
}

export const Form: FC<Props> = ({ owners, answerRequest }) => {
  const methods = useForm<Schema>({
    defaultValues: makeInitialValues(owners),
    resolver: yupResolver(schema),
  });
  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = methods;
  const ownersFieldArray = useFieldArray({ name: 'owners', control });

  const onSubmit: SubmitHandler<Schema> = async ({ owners }) => {
    await answerRequest({
      variables: {
        input: {
          owners: owners.map((owner) => ({
            ownerId: owner.ownerId,
            myNumber: owner.myNumber,
            myNumberImage: owner.myNumberImage,
            idImage0: owner.idImage0,
            idImage1: owner.idImage1,
          })),
        },
      },
    });
  };

  return (
    <FormProvider {...methods}>
      <form className={classNames('l-wrap-xs', styles.form)}>
        {ownersFieldArray.fields.map((field, index) => (
          <OwnerFields key={field.id} index={index} owner={owners[index]} />
        ))}
        <div className="u-ta-c">
          <Button primary onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
            入力する
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

const makeInitialValues = (owners: input.Owner[]) => ({
  owners: owners.map((owner) => ({
    ownerId: owner.id,
    _requestNumberConfirmation: owner.ownerRequest.requestNumberConfirmation,
    _requestIdentityConfirmation: owner.ownerRequest.requestIdentityConfirmation,
  })),
});
